// extracted by mini-css-extract-plugin
module.exports = {"spinnerContainer":"styles_spinnerContainer__26ZUV"};